import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../customerFullInfoState/customerFullInfoContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import Text from 'components/Text/Text';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import EditBtn from './components/EditBtn';
import style from './CustomerFullInfoControlPanel.module.scss';

const CustomerFullInfoControlPanel: React.FC = () => {
	const { changeCustomerFullInfoVisibleForm, customerFullInfoVisibleForm, customerForFullInfo } =
		useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const hasBpaAccess = useRoleAccess([UserRoles.SUPER_USER]);

	return (
		<div className={style.container} data-test="CustomerFullInfoControlPanel">
			<div className={style.heading}>
				<Text
					className={style.headingText}
					translationKey={customerForFullInfo?.name || null}
					size="xl"
					weight="bold"
				/>
				<EditBtn />
			</div>
			<div className={style.bookMarks}>
				<PageBookmarkBtn
					onClick={() => changeCustomerFullInfoVisibleForm('mainForm')}
					isActive={customerFullInfoVisibleForm === 'mainForm'}
					btnName="mainInfoBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeCustomerFullInfoVisibleForm('localizationForm')}
					isActive={customerFullInfoVisibleForm === 'localizationForm'}
					btnName="localizationBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeCustomerFullInfoVisibleForm('styleForm')}
					isActive={customerFullInfoVisibleForm === 'styleForm'}
					btnName="styleBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeCustomerFullInfoVisibleForm('softwareForm')}
					isActive={customerFullInfoVisibleForm === 'softwareForm'}
					btnName="softwareBookmark"
				/>
				<PageBookmarkBtn
					onClick={() => changeCustomerFullInfoVisibleForm('bpaForm')}
					isActive={customerFullInfoVisibleForm === 'bpaForm'}
					btnName="bpaBookmark"
					disabled={!hasBpaAccess || !customerForFullInfo?.isActiveBpa}
				/>
			</div>
		</div>
	);
};

export default CustomerFullInfoControlPanel;
